<template>
  <div class="drawalFailedStyle">
    <div class="headerStatus">
      <i class="iconfont icon-shibai-icon topicon"></i>
      <h3>电核失败</h3>
    </div>
    <p class="lineBox">
      <i class="line"></i>
    </p>
    <ul>
      <li
        class="infoList"
        v-for="(item, i) in list"
        :key="i"
      >
        <div class="infoListLeft">{{ item.key }}</div>
        <div class="infoListRight">{{ item.value }}</div>
      </li>
    </ul>
    <FooterTwoButton
      :leftNext="goToNextPage"
      :rightNext="withdraw"
      left="返回我的融资"
      right="重新提交"
    ></FooterTwoButton>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ServerBank from '@/components/ServerBank.vue';
import FooterTwoButton from './components/FooterTwoButton.vue';

export default {
  name: 'electricalEnergyFailure',
  data() {
    return {
      productCategory: '',
      danger: 'danger',
      drawHome: '返回我的融资',
      orderInfo: {
        corpName: '',
        productName: '',
        borrowerName: '',
        orderTime: '',
      }
    };
  },
  mounted() {
    this.getInfo();
    this.getProductCategory();
  },

  components: {
    ServerBank,
    FooterTwoButton,
  },
  methods: {
    getProductCategory() {
      this.$api.PublicPage.getProductDetail([this.$route.query.productId]).then((res) => {
        if (res.success) {
          this.productCategory = res.data[0].productCategory;
        }
      });
    },
    goToNextPage() {
      window.location.href = '/backloansuper/loan/supermarket/login2Url/v1.0?k=myLoad';
    },
    withdraw() {
      const { orderId = localStorage.getItem('orderId') } = this.commonForms;
      window.location.href = `/backloansuper/loan/supermarket/verifyFailJump/v1.0?orderId=${orderId}`;
    },
    getInfo() {
      const { orderId = localStorage.getItem('orderId') } = this.commonForms;
      this.$api.CommonForms.getOrderStatus({ orderId }).then((res) => {
        if (res.success) {
           const {
            corpName, productName, borrowerName, orderTime,
          } = res.data;
          this.orderInfo = {
            corpName, productName, borrowerName, orderTime,
          }
        }
      });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
    // 新增计算属性 list
    list() {
      const baseList = [
        // 当 productCategory 不为 '1' 时添加企业名称
        ...(this.productCategory !== '1' ? [{
          key: '企业名称：',
          value: this.orderInfo?.corpName || '',
        }] : []),
        {
          key: '借款人：',
          value: this.orderInfo?.borrowerName || '',
        },
        {
          key: '申请产品：',
          value: this.orderInfo?.productName || '',
        },
        {
          key: '失败原因：',
          value: '很遗憾，您本次未通过电核。',
        },
        {
          key: '申请时间：',
          value: this.orderInfo?.orderTime || '',
        },
      ];
      return baseList;
    }
  },
};
</script>
<style scoped>
.drawalFailedStyle {
  height: 100%;
  background: #fff;
}
.lineBox {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 2px;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 30px;
}
.line {
  display: block;
  height: 100%;
  width: 100%;
  background-color: #eee;
}
.topicon {
  font-size: 50px;
  color: red;
}
.infoList {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  justify-content: left;
  width: 90%;
  min-height: 30px;
  margin: 0 auto;
}
.infoListLeft {
  width: 100px;
  color: #7d828e;
  font-size: 14px;
  text-align: right;
}
.infoListRight {
  flex: 1;
  color: #000;
  font-size: 14px;
  text-align: left;
}
.nextStep {
  float: left;
  height: 44px;
  line-height: 44px;
  width: 48%;
  padding: 0;
  border-radius: 3px;
  box-sizing: border-box;
  margin-right: 4%;
}
.withdrawStyle {
  float: left;
  width: 48%;
  height: 44px;
  line-height: 44px;
  padding: 0;
  border-radius: 3px;
  box-shadow: border-box;
}
.headerStatus {
  padding-top: 35px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.btnBox {
  /* display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around; */
  margin-top: 30px;
  overflow: hidden;
  height: 60px;
  clear: both;
  padding: 0 15px;
}

.contractDraw {
  width: 150px;
  height: 40px;
  color: rgba(212, 48, 48, 1);
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(212, 48, 48, 1);
  border-radius: 3px;
}
</style>
